export default __webpack_public_path__ + "static/logo-full-6e2859264101442b2dfc8b4d159d513e.png";